// assets/javascript/cart/helpers/uuidUtils.js

import { v5 as uuidv5 } from 'uuid'

const NAMESPACE_UUID = 'e7aeefee-6753-4c12-aa90-8732b6436387'

export function generateUuidFromEmail(email) {
  return uuidv5(email.trim().toLowerCase(), NAMESPACE_UUID)
}
